module.exports = __webpack_public_path__ + "static/media/20201129_213135_877_IMG_1846.c42cb047.jpg";